<iframe
	*ngIf="safeUrl$ | async as safeUrl"
	[src]="safeUrl"
	[height]="height$ | async"
	scrolling="no"
	obgIframe
></iframe>
